/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { llmConfigurationAddFieldPost } from '../fn/llm-configuration/llm-configuration-add-field-post';
import { LlmConfigurationAddFieldPost$Params } from '../fn/llm-configuration/llm-configuration-add-field-post';
import { llmConfigurationAddLayoutPost } from '../fn/llm-configuration/llm-configuration-add-layout-post';
import { LlmConfigurationAddLayoutPost$Params } from '../fn/llm-configuration/llm-configuration-add-layout-post';
import { llmConfigurationAddLlmConfigPost } from '../fn/llm-configuration/llm-configuration-add-llm-config-post';
import { LlmConfigurationAddLlmConfigPost$Params } from '../fn/llm-configuration/llm-configuration-add-llm-config-post';
import { llmConfigurationAddTriggerPost } from '../fn/llm-configuration/llm-configuration-add-trigger-post';
import { LlmConfigurationAddTriggerPost$Params } from '../fn/llm-configuration/llm-configuration-add-trigger-post';
import { llmConfigurationAddTriggerResponsePost } from '../fn/llm-configuration/llm-configuration-add-trigger-response-post';
import { LlmConfigurationAddTriggerResponsePost$Params } from '../fn/llm-configuration/llm-configuration-add-trigger-response-post';
import { llmConfigurationDeleteFieldFieldIdDelete } from '../fn/llm-configuration/llm-configuration-delete-field-field-id-delete';
import { LlmConfigurationDeleteFieldFieldIdDelete$Params } from '../fn/llm-configuration/llm-configuration-delete-field-field-id-delete';
import { llmConfigurationDeleteTriggerResponseIdDelete } from '../fn/llm-configuration/llm-configuration-delete-trigger-response-id-delete';
import { LlmConfigurationDeleteTriggerResponseIdDelete$Params } from '../fn/llm-configuration/llm-configuration-delete-trigger-response-id-delete';
import { llmConfigurationDeleteTriggerTriggerIdDelete } from '../fn/llm-configuration/llm-configuration-delete-trigger-trigger-id-delete';
import { LlmConfigurationDeleteTriggerTriggerIdDelete$Params } from '../fn/llm-configuration/llm-configuration-delete-trigger-trigger-id-delete';
import { llmConfigurationEditFieldPut } from '../fn/llm-configuration/llm-configuration-edit-field-put';
import { LlmConfigurationEditFieldPut$Params } from '../fn/llm-configuration/llm-configuration-edit-field-put';
import { llmConfigurationEditLayoutPut } from '../fn/llm-configuration/llm-configuration-edit-layout-put';
import { LlmConfigurationEditLayoutPut$Params } from '../fn/llm-configuration/llm-configuration-edit-layout-put';
import { llmConfigurationEditTriggerPut } from '../fn/llm-configuration/llm-configuration-edit-trigger-put';
import { LlmConfigurationEditTriggerPut$Params } from '../fn/llm-configuration/llm-configuration-edit-trigger-put';
import { llmConfigurationEditTriggerResponsePut } from '../fn/llm-configuration/llm-configuration-edit-trigger-response-put';
import { LlmConfigurationEditTriggerResponsePut$Params } from '../fn/llm-configuration/llm-configuration-edit-trigger-response-put';
import { llmConfigurationGetActiveClientsGet } from '../fn/llm-configuration/llm-configuration-get-active-clients-get';
import { LlmConfigurationGetActiveClientsGet$Params } from '../fn/llm-configuration/llm-configuration-get-active-clients-get';
import { llmConfigurationGetFieldsLayoutIdGet } from '../fn/llm-configuration/llm-configuration-get-fields-layout-id-get';
import { LlmConfigurationGetFieldsLayoutIdGet$Params } from '../fn/llm-configuration/llm-configuration-get-fields-layout-id-get';
import { llmConfigurationGetFieldsLayoutIdGet$Plain } from '../fn/llm-configuration/llm-configuration-get-fields-layout-id-get-plain';
import { LlmConfigurationGetFieldsLayoutIdGet$Plain$Params } from '../fn/llm-configuration/llm-configuration-get-fields-layout-id-get-plain';
import { llmConfigurationGetLayoutsFleetIdGet } from '../fn/llm-configuration/llm-configuration-get-layouts-fleet-id-get';
import { LlmConfigurationGetLayoutsFleetIdGet$Params } from '../fn/llm-configuration/llm-configuration-get-layouts-fleet-id-get';
import { llmConfigurationGetLayoutsFleetIdGet$Plain } from '../fn/llm-configuration/llm-configuration-get-layouts-fleet-id-get-plain';
import { LlmConfigurationGetLayoutsFleetIdGet$Plain$Params } from '../fn/llm-configuration/llm-configuration-get-layouts-fleet-id-get-plain';
import { llmConfigurationGetLlmConfigsGet } from '../fn/llm-configuration/llm-configuration-get-llm-configs-get';
import { LlmConfigurationGetLlmConfigsGet$Params } from '../fn/llm-configuration/llm-configuration-get-llm-configs-get';
import { llmConfigurationGetTriggerResponsesLayoutTriggerIdGet } from '../fn/llm-configuration/llm-configuration-get-trigger-responses-layout-trigger-id-get';
import { LlmConfigurationGetTriggerResponsesLayoutTriggerIdGet$Params } from '../fn/llm-configuration/llm-configuration-get-trigger-responses-layout-trigger-id-get';
import { llmConfigurationGetTriggersLayoutIdGet } from '../fn/llm-configuration/llm-configuration-get-triggers-layout-id-get';
import { LlmConfigurationGetTriggersLayoutIdGet$Params } from '../fn/llm-configuration/llm-configuration-get-triggers-layout-id-get';
import { llmConfigurationGetTriggersLayoutIdGet$Plain } from '../fn/llm-configuration/llm-configuration-get-triggers-layout-id-get-plain';
import { LlmConfigurationGetTriggersLayoutIdGet$Plain$Params } from '../fn/llm-configuration/llm-configuration-get-triggers-layout-id-get-plain';
import { llmConfigurationToggleLlmConfigPut } from '../fn/llm-configuration/llm-configuration-toggle-llm-config-put';
import { LlmConfigurationToggleLlmConfigPut$Params } from '../fn/llm-configuration/llm-configuration-toggle-llm-config-put';
import { LlmField } from '../models/llm-field';
import { LlmLayout } from '../models/llm-layout';
import { LlmLayoutTrigger } from '../models/llm-layout-trigger';

@Injectable({ providedIn: 'root' })
export class LlmConfigurationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `llmConfigurationGetLlmConfigsGet()` */
  static readonly LlmConfigurationGetLlmConfigsGetPath = '/LLMConfiguration/GetLLMConfigs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationGetLlmConfigsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetLlmConfigsGet$Response(params?: LlmConfigurationGetLlmConfigsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationGetLlmConfigsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationGetLlmConfigsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetLlmConfigsGet(params?: LlmConfigurationGetLlmConfigsGet$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationGetLlmConfigsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationGetActiveClientsGet()` */
  static readonly LlmConfigurationGetActiveClientsGetPath = '/LLMConfiguration/GetActiveClients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationGetActiveClientsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetActiveClientsGet$Response(params?: LlmConfigurationGetActiveClientsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationGetActiveClientsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationGetActiveClientsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetActiveClientsGet(params?: LlmConfigurationGetActiveClientsGet$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationGetActiveClientsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationAddLlmConfigPost()` */
  static readonly LlmConfigurationAddLlmConfigPostPath = '/LLMConfiguration/AddLLMConfig';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationAddLlmConfigPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationAddLlmConfigPost$Response(params?: LlmConfigurationAddLlmConfigPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationAddLlmConfigPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationAddLlmConfigPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationAddLlmConfigPost(params?: LlmConfigurationAddLlmConfigPost$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationAddLlmConfigPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationToggleLlmConfigPut()` */
  static readonly LlmConfigurationToggleLlmConfigPutPath = '/LLMConfiguration/ToggleLLMConfig';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationToggleLlmConfigPut()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationToggleLlmConfigPut$Response(params?: LlmConfigurationToggleLlmConfigPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationToggleLlmConfigPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationToggleLlmConfigPut$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationToggleLlmConfigPut(params?: LlmConfigurationToggleLlmConfigPut$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationToggleLlmConfigPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationGetLayoutsFleetIdGet()` */
  static readonly LlmConfigurationGetLayoutsFleetIdGetPath = '/LLMConfiguration/GetLayouts/{fleetId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationGetLayoutsFleetIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetLayoutsFleetIdGet$Plain$Response(params: LlmConfigurationGetLayoutsFleetIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmLayout>>> {
    return llmConfigurationGetLayoutsFleetIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationGetLayoutsFleetIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetLayoutsFleetIdGet$Plain(params: LlmConfigurationGetLayoutsFleetIdGet$Plain$Params, context?: HttpContext): Observable<Array<LlmLayout>> {
    return this.llmConfigurationGetLayoutsFleetIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LlmLayout>>): Array<LlmLayout> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationGetLayoutsFleetIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetLayoutsFleetIdGet$Response(params: LlmConfigurationGetLayoutsFleetIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmLayout>>> {
    return llmConfigurationGetLayoutsFleetIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationGetLayoutsFleetIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetLayoutsFleetIdGet(params: LlmConfigurationGetLayoutsFleetIdGet$Params, context?: HttpContext): Observable<Array<LlmLayout>> {
    return this.llmConfigurationGetLayoutsFleetIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LlmLayout>>): Array<LlmLayout> => r.body)
    );
  }

  /** Path part for operation `llmConfigurationAddLayoutPost()` */
  static readonly LlmConfigurationAddLayoutPostPath = '/LLMConfiguration/AddLayout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationAddLayoutPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationAddLayoutPost$Response(params?: LlmConfigurationAddLayoutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationAddLayoutPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationAddLayoutPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationAddLayoutPost(params?: LlmConfigurationAddLayoutPost$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationAddLayoutPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationEditLayoutPut()` */
  static readonly LlmConfigurationEditLayoutPutPath = '/LLMConfiguration/EditLayout';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationEditLayoutPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationEditLayoutPut$Response(params?: LlmConfigurationEditLayoutPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationEditLayoutPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationEditLayoutPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationEditLayoutPut(params?: LlmConfigurationEditLayoutPut$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationEditLayoutPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationGetFieldsLayoutIdGet()` */
  static readonly LlmConfigurationGetFieldsLayoutIdGetPath = '/LLMConfiguration/GetFields/{layoutId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationGetFieldsLayoutIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetFieldsLayoutIdGet$Plain$Response(params: LlmConfigurationGetFieldsLayoutIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmField>>> {
    return llmConfigurationGetFieldsLayoutIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationGetFieldsLayoutIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetFieldsLayoutIdGet$Plain(params: LlmConfigurationGetFieldsLayoutIdGet$Plain$Params, context?: HttpContext): Observable<Array<LlmField>> {
    return this.llmConfigurationGetFieldsLayoutIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LlmField>>): Array<LlmField> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationGetFieldsLayoutIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetFieldsLayoutIdGet$Response(params: LlmConfigurationGetFieldsLayoutIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmField>>> {
    return llmConfigurationGetFieldsLayoutIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationGetFieldsLayoutIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetFieldsLayoutIdGet(params: LlmConfigurationGetFieldsLayoutIdGet$Params, context?: HttpContext): Observable<Array<LlmField>> {
    return this.llmConfigurationGetFieldsLayoutIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LlmField>>): Array<LlmField> => r.body)
    );
  }

  /** Path part for operation `llmConfigurationAddFieldPost()` */
  static readonly LlmConfigurationAddFieldPostPath = '/LLMConfiguration/AddField';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationAddFieldPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationAddFieldPost$Response(params?: LlmConfigurationAddFieldPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationAddFieldPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationAddFieldPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationAddFieldPost(params?: LlmConfigurationAddFieldPost$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationAddFieldPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationEditFieldPut()` */
  static readonly LlmConfigurationEditFieldPutPath = '/LLMConfiguration/EditField';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationEditFieldPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationEditFieldPut$Response(params?: LlmConfigurationEditFieldPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationEditFieldPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationEditFieldPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationEditFieldPut(params?: LlmConfigurationEditFieldPut$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationEditFieldPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationDeleteFieldFieldIdDelete()` */
  static readonly LlmConfigurationDeleteFieldFieldIdDeletePath = '/LLMConfiguration/DeleteField/{fieldId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationDeleteFieldFieldIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationDeleteFieldFieldIdDelete$Response(params: LlmConfigurationDeleteFieldFieldIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationDeleteFieldFieldIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationDeleteFieldFieldIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationDeleteFieldFieldIdDelete(params: LlmConfigurationDeleteFieldFieldIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationDeleteFieldFieldIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationGetTriggersLayoutIdGet()` */
  static readonly LlmConfigurationGetTriggersLayoutIdGetPath = '/LLMConfiguration/GetTriggers/{layoutId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationGetTriggersLayoutIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetTriggersLayoutIdGet$Plain$Response(params: LlmConfigurationGetTriggersLayoutIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmLayoutTrigger>>> {
    return llmConfigurationGetTriggersLayoutIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationGetTriggersLayoutIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetTriggersLayoutIdGet$Plain(params: LlmConfigurationGetTriggersLayoutIdGet$Plain$Params, context?: HttpContext): Observable<Array<LlmLayoutTrigger>> {
    return this.llmConfigurationGetTriggersLayoutIdGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LlmLayoutTrigger>>): Array<LlmLayoutTrigger> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationGetTriggersLayoutIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetTriggersLayoutIdGet$Response(params: LlmConfigurationGetTriggersLayoutIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LlmLayoutTrigger>>> {
    return llmConfigurationGetTriggersLayoutIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationGetTriggersLayoutIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetTriggersLayoutIdGet(params: LlmConfigurationGetTriggersLayoutIdGet$Params, context?: HttpContext): Observable<Array<LlmLayoutTrigger>> {
    return this.llmConfigurationGetTriggersLayoutIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LlmLayoutTrigger>>): Array<LlmLayoutTrigger> => r.body)
    );
  }

  /** Path part for operation `llmConfigurationAddTriggerPost()` */
  static readonly LlmConfigurationAddTriggerPostPath = '/LLMConfiguration/AddTrigger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationAddTriggerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationAddTriggerPost$Response(params?: LlmConfigurationAddTriggerPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationAddTriggerPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationAddTriggerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationAddTriggerPost(params?: LlmConfigurationAddTriggerPost$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationAddTriggerPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationEditTriggerPut()` */
  static readonly LlmConfigurationEditTriggerPutPath = '/LLMConfiguration/EditTrigger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationEditTriggerPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationEditTriggerPut$Response(params?: LlmConfigurationEditTriggerPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationEditTriggerPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationEditTriggerPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationEditTriggerPut(params?: LlmConfigurationEditTriggerPut$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationEditTriggerPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationDeleteTriggerTriggerIdDelete()` */
  static readonly LlmConfigurationDeleteTriggerTriggerIdDeletePath = '/LLMConfiguration/DeleteTrigger/{triggerId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationDeleteTriggerTriggerIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationDeleteTriggerTriggerIdDelete$Response(params: LlmConfigurationDeleteTriggerTriggerIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationDeleteTriggerTriggerIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationDeleteTriggerTriggerIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationDeleteTriggerTriggerIdDelete(params: LlmConfigurationDeleteTriggerTriggerIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationDeleteTriggerTriggerIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationGetTriggerResponsesLayoutTriggerIdGet()` */
  static readonly LlmConfigurationGetTriggerResponsesLayoutTriggerIdGetPath = '/LLMConfiguration/GetTriggerResponses/{layoutTriggerId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationGetTriggerResponsesLayoutTriggerIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetTriggerResponsesLayoutTriggerIdGet$Response(params: LlmConfigurationGetTriggerResponsesLayoutTriggerIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationGetTriggerResponsesLayoutTriggerIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationGetTriggerResponsesLayoutTriggerIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationGetTriggerResponsesLayoutTriggerIdGet(params: LlmConfigurationGetTriggerResponsesLayoutTriggerIdGet$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationGetTriggerResponsesLayoutTriggerIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationAddTriggerResponsePost()` */
  static readonly LlmConfigurationAddTriggerResponsePostPath = '/LLMConfiguration/AddTriggerResponse';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationAddTriggerResponsePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationAddTriggerResponsePost$Response(params?: LlmConfigurationAddTriggerResponsePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationAddTriggerResponsePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationAddTriggerResponsePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationAddTriggerResponsePost(params?: LlmConfigurationAddTriggerResponsePost$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationAddTriggerResponsePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationEditTriggerResponsePut()` */
  static readonly LlmConfigurationEditTriggerResponsePutPath = '/LLMConfiguration/EditTriggerResponse';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationEditTriggerResponsePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationEditTriggerResponsePut$Response(params?: LlmConfigurationEditTriggerResponsePut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationEditTriggerResponsePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationEditTriggerResponsePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  llmConfigurationEditTriggerResponsePut(params?: LlmConfigurationEditTriggerResponsePut$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationEditTriggerResponsePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `llmConfigurationDeleteTriggerResponseIdDelete()` */
  static readonly LlmConfigurationDeleteTriggerResponseIdDeletePath = '/LLMConfiguration/DeleteTriggerResponse/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `llmConfigurationDeleteTriggerResponseIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationDeleteTriggerResponseIdDelete$Response(params: LlmConfigurationDeleteTriggerResponseIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return llmConfigurationDeleteTriggerResponseIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `llmConfigurationDeleteTriggerResponseIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  llmConfigurationDeleteTriggerResponseIdDelete(params: LlmConfigurationDeleteTriggerResponseIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.llmConfigurationDeleteTriggerResponseIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
